/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Activity_Removed_EventInputs */



/**
* | output |
* | --- |
* | "Removed" |
*
* @param {Assistant_Activity_Removed_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_activity_removed_event = /** @type {((inputs?: Assistant_Activity_Removed_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Activity_Removed_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimé")
	if (locale === "de") return /** @type {LocalizedString} */ ("ENTFERNT")
	if (locale === "it") return /** @type {LocalizedString} */ ("RIMOSSO")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удаленный")
	if (locale === "es") return /** @type {LocalizedString} */ ("Remoto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("已移除")
	if (locale === "ja") return /** @type {LocalizedString} */ ("削除済み")
	if (locale === "hi") return /** @type {LocalizedString} */ ("निकाला गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Removido")
	return /** @type {LocalizedString} */ ("Removed")
});